import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3498">
      <Navbar data-id="element-3499" />
      <main data-id="element-3500">
        <ConsularAffairs data-id="element-3501" />
      </main>
      <Footer data-id="element-3502" />
      <FeedbackPopup data-id="element-3503" />
    </div>;
}